import * as JSONMapper from "json-mapper";
import {jsonProperty} from "json-mapper-reflect";
import {Moment} from "moment";
import {AvdbIssue} from "./avdb-issue";

export class AvdbTypeIssue extends AvdbIssue {
	@jsonProperty(JSONMapper.timestampFromISO)
	availableAt: Moment;

	constructor(data?: Partial<AvdbTypeIssue>) {
		super();
		Object.assign(this, data);
	}
}
